import { Box } from '@mui/material'
import clockSkipIcon from 'assets/Clockskip.png'
import skipIcon from 'assets/skip.png'
import { COLORS } from 'styles/colors'
import { MetricCardData, MetricPart } from './dayMetrics'

const partSx: Record<MetricPart['tone'], object> = {
	value: {
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '20px',
		color: COLORS.black,
	},
	unit: {
		ml: '4px',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '16px',
		color: COLORS.secondary,
		whiteSpace: 'nowrap',
	},
	muted: {
		ml: '4px',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '16px',
		color: '#A3A3A8',
		whiteSpace: 'nowrap',
	},
	prefix: {
		mr: '4px',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '16px',
		color: COLORS.secondary,
		whiteSpace: 'nowrap',
	},
}

const cornerChipSx = {
	position: 'absolute',
	top: '3px',
	right: '8px',
	display: 'inline-flex',
	alignItems: 'center',
	px: '8px',
	py: '3px',
	borderRadius: '12px',
	backgroundColor: '#F7F7F7',
	color: '#7F7F84',
	fontSize: '12px',
	fontWeight: 400,
	lineHeight: '16px',
	whiteSpace: 'nowrap',
} as const

const MetricCard = ({ card }: { card: MetricCardData }) => {
	const timeRange = card.aside?.startsWith('с ') ? card.aside : undefined
	return (
		<Box
			sx={{
				position: 'relative',
				flex: '0 0 264px',
				width: '264px',
				height: '104px',
				pt: '24px',
				pl: '24px',
				pr: '16px',
				pb: '16px',
				borderRadius: '12px',
				backgroundColor: COLORS.white,
				boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.08)',
				boxSizing: 'border-box',
				overflow: 'hidden',
			}}
		>
			{card.badge && !card.empty && (
				<Box
					component='span'
					sx={{
						position: 'absolute',
						top: '3px',
						right: '8px',
						display: 'inline-flex',
						alignItems: 'center',
						gap: '4px',
						px: '8px',
						py: '3px',
						borderRadius: '12px',
						fontSize: '12px',
						fontWeight: card.badge.tone === 'neutral' ? 400 : 500,
						lineHeight: '16px',
						whiteSpace: 'nowrap',
						backgroundColor:
							card.badge.tone === 'neutral' ? '#F7F7F7' : '#FDEDEC',
						color: card.badge.tone === 'neutral' ? '#7F7F84' : '#EB4D3D',
					}}
				>
					{card.badge.tone === 'percent' && (
						<Box
							component='img'
							src={skipIcon}
							alt=''
							sx={{ width: '16px', height: '16px', display: 'block' }}
						/>
					)}
					{card.badge.tone === 'alert' && (
						<Box
							component='img'
							src={clockSkipIcon}
							alt=''
							sx={{ width: '16px', height: '16px', display: 'block' }}
						/>
					)}
					{card.badge.text}
				</Box>
			)}
			{timeRange && !card.empty && (
				<Box component='span' sx={cornerChipSx}>
					{timeRange}
				</Box>
			)}
			{card.empty ? (
				<Box
					sx={{
						fontSize: '12px',
						fontWeight: 400,
						lineHeight: '16px',
						color: COLORS.secondary,
					}}
				>
					Нет данных
				</Box>
			) : (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'baseline',
						flexWrap: 'nowrap',
						gap: '4px',
						pr: timeRange ? '108px' : 0,
						minWidth: 0,
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'baseline',
							flexWrap: 'nowrap',
							flexShrink: 0,
						}}
					>
						{card.parts.map((part, index) => (
							<Box
								key={`${card.id}-${index}`}
								component='span'
								sx={{
									...partSx[part.tone],
									...(part.tone === 'unit' && index < card.parts.length - 1
										? { mr: '4px' }
										: {}),
								}}
							>
								{part.text}
							</Box>
						))}
					</Box>
					{card.aside && !timeRange && (
						<Box
							component='span'
							sx={{
								fontSize: '12px',
								fontWeight: 400,
								lineHeight: '16px',
								color: COLORS.secondary,
								whiteSpace: 'nowrap',
							}}
						>
							{card.aside}
						</Box>
					)}
				</Box>
			)}
			<Box
				sx={{
					mt: '4px',
					fontSize: '14px',
					fontWeight: 400,
					lineHeight: '18px',
					color: COLORS.black,
				}}
			>
				{card.label}
				{card.labelNote && (
					<Box
						component='span'
						sx={{ display: 'block', color: COLORS.secondary }}
					>
						{card.labelNote}
					</Box>
				)}
			</Box>
		</Box>
	)
}

export default MetricCard
